// import { Button, message, Switch, Table, Upload } from "antd";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   ErrorToast,
//   ShowInputError,
//   SuccessToast,
// } from "../../../widgets/AppToast";
// import AppInput from "../../../components/AppInput";
// import { post } from "../../../services/services";
// import { ApiURL } from "../../../services/apiConstants";
// import SelectInput from "../../../components/SelectInput";
// import VoyageDetails from "../../../components/VoyageDetails";
// import moment from "moment";
// import { UploadOutlined } from "@ant-design/icons";
// import useDocumentUpload from "../../../hooks/useDocumentUpload";
// import useUserData from "../../../hooks/useUserData";
// import TextArea from "antd/es/input/TextArea";
// import AddOliRecordLogPartOneModal from "./components/IcodeAddEntry";
// import PdfPreviewModal from "../../common/pdfreviewbutton";
// import { formatDate } from "../../../utils/dateFormatter";

// function AddOliRecordLogPartOne() {
//   const navigate = useNavigate();
//   const user = useUserData();
//   const designation = user?.data?.designation;
//   const [loader, set_loader] = useState(false);
//   const [errors, set_errors] = useState({});
//   const [staff_dashboard, set_staff_dashboard] = useState([]);
//   const [code, set_code] = useState("");
//   const [date, set_date] = useState(moment().format("YYYY-MM-DD"));
//   const [signature, set_signature] = useState("");
//   const [codeList, setCodeList] = useState([]);
//   const [codeItemList, setCodeItemList] = useState([]);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [checked, setChecked] = useState(false);
//   const [parent_id, set_parent_id] = useState("");
//   const { documentList, handleDocumentChange, getFilesForUpload } =
//     useDocumentUpload();
//   const [previous_log_date, set_Previous_Log_Date] = useState("");
//   const [tankList, SetTankList] = useState([]);


//   const LIST_OIL_RECORD_CODE_API = () => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("orb_part", "1");
//       post(ApiURL.list_code_categories_st, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           const newRespones = res?.code_categories?.map((item) => {
//             return {
//               value: item?.id,
//               label: `(${item?.value}) ` + item?.label,
//             };
//           });
//           LIST_OIL_RECORD_ITEM_API(newRespones?.[0]?.value);
//           setCodeList(newRespones);
//           set_Previous_Log_Date(res?.last_record);
//         }
//       });
//     } catch (error) {
//       console.error("Error fetching Code list:", error);
//     }
//   };

//   const LIST_OIL_RECORD_ITEM_API = (code_id) => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("code_category_id", code_id);
//       FORM_DATA.append("orb_part", "1");
//       post(ApiURL.list_subdetails_category_st, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           const newRes = res?.subdetails?.map((item) => {
//             return {
//               value: item?.id,
//               label: item?.sub_code_name,
//               sub_code_name: item?.subdetails_child,
//             };
//           });
//           setCodeItemList(newRes);
//         }
//       });
//     } catch (error) {
//       console.error("Error fetching Code Item list:", error);
//     }
//   };

//   const SEND_NOTIFICATION_CHIEF_ENGINEER = async (record_id) => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
//       FORM_DATA.append("orb_part", "1");
//       FORM_DATA.append("record_id", record_id);
//       FORM_DATA.append(
//         "description",
//         "A new ORB Part 1 record has been created. Please review and confirm it at your earliest convenience"
//       );
//       const response = await post(ApiURL?.notification_save_req, FORM_DATA);
//       if (response?.status === true) {
//         SuccessToast(
//           "Congratulations!",
//           response?.message || "No message returned."
//         );
//       } else {
//         ErrorToast("Error", response?.message || "Something went wrong.");
//       }
//     } catch (error) {
//       ErrorToast(
//         "Request Failed",
//         "Could not complete the request. Please try again."
//       );
//     }
//   };

//   const ADD_OIL_RECORD_LOGBOOK_APIS = async (checked1) => {
//     const files = getFilesForUpload();
//     set_loader(true);
//     if (
//       selectedItems?.some((item) => item.value === null || item.value === "")
//     ) {
//       alert("All checked input should be filled");
//       set_loader(false);
//       return;
//     }
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
//       FORM_DATA.append("orb_part", "1");
//       FORM_DATA.append("code_category_id", code);
//       FORM_DATA.append("sub_detail_id", JSON.stringify(selectedItems));
//       FORM_DATA.append("sub_detail_values", JSON.stringify(selectedItems));
//       FORM_DATA.append("date", date);
//       FORM_DATA.append("operation_details", signature);
//       files?.forEach((files) => {
//         FORM_DATA.append("files", files);
//       });
//       post(ApiURL.add_orb_details_st, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           SuccessToast("Congratulation!!", res?.message);
//           set_loader(false);
//           set_parent_id(res?.id);
//           if (designation && designation !== "Chief Engineer") {
//             SEND_NOTIFICATION_CHIEF_ENGINEER(res?.id);
//           }
//           if (code !== 30) {
//             navigate("/list-oil-record-log-one");
//           }
//           //  navigate("/list-oil-record-log-one");
//         } else {
//           ErrorToast("Error message", res?.message);
//           const error = res?.response?.data?.errors || {};

//           set_errors(error);
//           set_loader(false);
//         }
//       });
//     } catch (error) {
//       console.log("Errors *****", error);
//     }
//   };

//   const SHIP_TANKS_LIST_API = async () => {
//     try {
//       const FORM_DATA = new FormData();
//       const staff_Details = JSON.parse(localStorage.getItem("user_data"));
//       FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
//       FORM_DATA.append("category_of_tank", "IOPP");
//       post(ApiURL.list_tanks_by_ship, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           SetTankList(res?.tanks);
//         }
//       });
//     } catch (error) {
//       console.error("Error fetching Sub Tanks list:", error);
//     }
//   };

//   useEffect(() => {
//     const staff_dashboards = localStorage.getItem("staff_dashboard");
//     const parsedData = JSON.parse(staff_dashboards);
//     set_staff_dashboard(parsedData);
//     LIST_OIL_RECORD_CODE_API();
//     SHIP_TANKS_LIST_API();
//   }, []);

//   const groupedOptions = codeItemList.flatMap((item) => {
//     if (item.sub_code_name.length > 0) {
//       return {
//         label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
//         options: item.sub_code_name.map((sub, index) => ({
//           value: `${item.value}-${index}`,
//           label: ` ${sub?.subdetails_child}`,
//         })),
//       };
//     } else {
//       return {
//         value: item.value,
//         label: item.label,
//       };
//     }
//   });

//   const handleCheckboxChange = (value) => {
//     setSelectedItems((prevItems) => {
//       const exists = prevItems.find((item) => item.id === value);
//       if (exists) {
//         return prevItems.filter((item) => item.id !== value);
//       } else {
//         return [...prevItems, { id: value, value: "" }];
//       }
//     });
//   };

//   const handleInputChange = (id, value, key = "value") => {
//     setSelectedItems((prev) =>
//       prev.map((item) => (item.id === id ? { ...item, [key]: value } : item))
//     );
//   };

//   const getDocUrl = (file) => {
//     if (file.url) return file.url; // existing file
//     if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
//     return null;
//   };

//   const handlePreviews = async (file) => {
//     const url = getDocUrl(file);
//     if (!url) {
//       message.error("No preview available for this file");
//       return;
//     }
//     window.open(url, "_blank");
//   };

//   useEffect(() => {
//     if (checked) {
//       setOpen(true);
//     }
//   }, [checked, parent_id]);

//   const hasFormChanged = () => {
//     return (
//       code &&
//       date &&
//       signature &&
//       selectedItems.length > 0 &&
//       selectedItems.every((item) => item.value && item.value.trim() !== "")
//     );
//   };

//   const columns = [
//     { title: "ID", dataIndex: "id", key: "id", align: "center" },
//     {
//       title: "Tank Name",
//       dataIndex: "sub_tank_name",
//       key: "sub_tank_name",
//       align: "center",
//     },
//     {
//       title: "Max capacity",
//       dataIndex: "capacity",
//       key: "capacity",
//       align: "center",
//     },
//     {
//       title: "Tank Type",
//       dataIndex: "tank_type",
//       key: "tank_type",
//       align: "center",
//     },
//     {
//       title: "Category",
//       dataIndex: "category_name",
//       key: "category_name",
//       align: "center",
//     },
//     {
//       title: "Created Date",
//       dataIndex: "created_at",
//       align: "center",
//       key: "created_at",
//       render: (text, record) => <span>{formatDate(record?.created_at)}</span>,
//     },
//     {
//       title: "Updated Date",
//       dataIndex: "updated_at",
//       align: "center",
//       key: "updated_at",
//       render: (text, record) => <span>{formatDate(record?.updated_at)}</span>,
//     },
//   ];

//   return (
//     <>
//       <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
//       <div className="white-container">
//         <br />
//         <div className="col-6" style={{ marginLeft: "-10px" }}>
//           <h3>Oil Record book Part 1 Information</h3>
//         </div>
//         <div className="col-6">
//           <PdfPreviewModal pdfFileName="ORB-PART-1.pdf" />
//         </div>
//         <br />
//         <br />
//         <div className="row">
//           <div className="col-6">
//             <SelectInput
//               label="Code"
//               value={code}
//               placeholder=" -- Selecte Code  -- "
//               style={{ width: "100%" }}
//               onChange={(value) => {
//                 if (value !== 30) {
//                   setChecked(false);
//                 }
//                 set_code(value);
//                 setSelectedItems([]);
//                 LIST_OIL_RECORD_ITEM_API(value);
//               }}
//               options={codeList}
//               errors={errors?.code_category_id}
//             />
//           </div>

//           <div className="col-6">
//             <AppInput
//               type="date"
//               label="Date"
//               placeholder="Date"
//               value={date}
//               onChange={(e) => set_date(e.target.value)}
//               errors={errors.date}
//               showInfo={code === 30}
//               infoMessage="Current Date - When the missed entry is being logged"
//               min={previous_log_date}
//               max={new Date().toISOString().split("T")[0]}
//             />
//           </div>
//         </div>

//         {code == 30 && (
//           <div
//             className="row"
//             style={{ marginLeft: "5px", marginBottom: "7px" }}
//           >
//             <div style={{ marginRight: "5px" }}>
//               <label>
//                 Do you want to record a missed operation entry (Yes / No)
//               </label>
//             </div>
//             <Switch
//               value={checked}
//               onChange={(checked) => {
//                 if (hasFormChanged()) {
//                   setChecked(checked);
//                   ADD_OIL_RECORD_LOGBOOK_APIS("checked");
//                 }
//               }}
//               checkedChildren="No"
//               unCheckedChildren="Yes"
//               style={{
//                 backgroundColor: checked ? "green" : "red",
//               }}
//             />
//           </div>
//         )}

//         <>
//           {code && (
//             <div
//               className="col-12"
//               style={{
//                 lineHeight: "2",
//                 border: "1px solid #d9d9d9",
//                 borderRadius: "5px",
//                 marginBottom: "5px",
//               }}
//             >
//               <strong className="form-label">Select Items:</strong>
//               {groupedOptions.map((optionGroup, index) => (
//                 <div key={index} className="mb-3">
//                   {/* Main Label as Checkbox */}
//                   <div className="row align-items-center mb-2">
//                     <div className="col-6">
//                       <div className="form-check">
//                         {optionGroup?.options?.length > 1 ? (
//                           ""
//                         ) : (
//                           <input
//                             className="form-check-input"
//                             type="checkbox"
//                             value={optionGroup.label}
//                             checked={selectedItems.some(
//                               (item) => item.id === optionGroup.value
//                             )}
//                             onChange={() =>
//                               handleCheckboxChange(optionGroup.value)
//                             }
//                             id={`group-checkbox-${index}`}
//                           />
//                         )}
//                         <label
//                           className="form-check-label"
//                           htmlFor={`group-checkbox-${index}`}
//                         >
//                           {typeof optionGroup.label === "string" ? (
//                             <strong>{optionGroup.label}</strong>
//                           ) : (
//                             <strong>{optionGroup.label.props.children}</strong>
//                           )}
//                         </label>
//                       </div>
//                     </div>

//                     {/* Input Field for Main Label */}
//                     <div className="col-6" style={{ marginLeft: "22px" }}>
//                       {selectedItems.some(
//                         (item) => item.id === optionGroup.value
//                       ) && (
//                         <TextArea
//                           required
//                           maxLength={1000}
//                           className="form-control"
//                           autoSize={{ minRows: 2 }}
//                           placeholder={
//                             typeof optionGroup.label === "string"
//                               ? optionGroup.label
//                               : optionGroup.label.props.children
//                           }
//                           value={
//                             selectedItems.find(
//                               (item) => item.id === optionGroup.value
//                             )?.value || ""
//                           }
//                           onChange={(e) =>
//                             handleInputChange(optionGroup.value, e.target.value)
//                           }
//                         />
//                       )}
//                     </div>

//                     {/* Special Input - Only for 112 */}
//                     {Number(optionGroup.value) === 112 && (
//                       <div className="col-6" style={{ marginBottom: 20 }}>
//                         {selectedItems.some(
//                           (item) => Number(item.id) === 112
//                         ) && (
//                           <TextArea
//                             required
//                             maxLength={1000}
//                             className="form-control"
//                             autoSize={{ minRows: 2 }}
//                             placeholder="Discharged Volume"
//                             value={
//                               selectedItems.find(
//                                 (item) => Number(item.id) === 112
//                               )?.dischargedvolume || ""
//                             }
//                             onChange={(e) =>
//                               handleInputChange(
//                                 112,
//                                 e.target.value,
//                                 "dischargedvolume"
//                               )
//                             }
//                           />
//                         )}
//                       </div>
//                     )}
//                   </div>

//                   {/* Sub-options */}
//                   {optionGroup.options && (
//                     <div
//                       className="ms-3"
//                       style={{ marginLeft: "30px", padding: "10px" }}
//                     >
//                       {optionGroup.options.map((option) => (
//                         <div
//                           key={option.value}
//                           className="row align-items-center mb-2"
//                         >
//                           {/* Left Side - Checkbox */}
//                           <div className="col-6">
//                             <div className="form-check">
//                               <input
//                                 className="form-check-input"
//                                 type="checkbox"
//                                 value={option.value}
//                                 checked={selectedItems.some(
//                                   (item) => item.id === option.value
//                                 )}
//                                 onChange={() =>
//                                   handleCheckboxChange(option.value)
//                                 }
//                                 id={`checkbox-${option.value}`}
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor={`checkbox-${option.value}`}
//                               >
//                                 {option.label}
//                               </label>
//                             </div>
//                           </div>

//                           {/* Right Side - Input Field */}
//                           <div className="col-6" style={{ padding: "5px" }}>
//                             {selectedItems.some(
//                               (item) => item.id === option.value
//                             ) && (
//                               <TextArea
//                                 required
//                                 maxLength={1000}
//                                 className="form-control"
//                                 autoSize={{ minRows: 2 }}
//                                 placeholder={option.label}
//                                 value={
//                                   selectedItems.find(
//                                     (item) => item.id === option.value
//                                   )?.value || ""
//                                 }
//                                 onChange={(e) =>
//                                   handleInputChange(
//                                     option.value,
//                                     e.target.value
//                                   )
//                                 }
//                               />
//                             )}
//                           </div>

//                           {/* Special case: two inputs only for id '111-3' and code '24' */}
//                           {/* First Input - Only for id 111-3 */}
//                           {/* {option.value === "111-3" && (
//                             <div className="col-6" style={{ padding: "5px" }}>
//                               {selectedItems.some(
//                                 (item) => item.id === option.value
//                               ) && (
//                                 <TextArea
//                                   required
//                                   maxLength={1000}
//                                   className="form-control"
//                                   autoSize={{ minRows: 2 }}
//                                   placeholder={"Evaporation Volume"}
//                                   value={
//                                     selectedItems.find(
//                                       (item) => item.id === option.value
//                                     )?.evaporationVolume || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleInputChange(
//                                       option.value,
//                                       e.target.value,
//                                       "evaporationVolume"
//                                     )
//                                   }
//                                 />
//                               )}
//                             </div>
//                           )} */}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           )}
//           {errors.sub_detail_values && (
//             <ShowInputError errorMessage={errors.sub_detail_values} />
//           )}
//           <div className="row" style={{ alignItems: "center" }}>
//             <div className="col-6">
//               <AppInput
//                 label="Name of operation incharge"
//                 placeholder="Name of operation incharge"
//                 value={signature}
//                 onChange={(e) => set_signature(e.target.value)}
//                 errors={errors.operation_details}
//                 showInfo={code === 30}
//                 infoMessage="Officer making this entry now"
//               />
//             </div>
//             {!checked && (
//               <div className="col-6">
//                 <div
//                   className="input-box"
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "8px",
//                     alignItems: "flex-start",
//                   }}
//                 >
//                   <label>Select File</label>
//                   <Upload
//                     accept=".pdf,.doc,.docx,.xls,.xlsx"
//                     multiple
//                     fileList={documentList}
//                     onChange={handleDocumentChange}
//                     onPreview={handlePreviews}
//                     beforeUpload={() => false}
//                     listType="picture"
//                   >
//                     <Button
//                       icon={<UploadOutlined />}
//                       type="primary"
//                       style={{
//                         borderRadius: "50%",
//                         padding: "10px",
//                         width: "40px",
//                         height: "40px",
//                         marginLeft: "10px",
//                       }}
//                     ></Button>
//                   </Upload>
//                 </div>
//               </div>
//             )}
//           </div>
//           {!checked && (
//             <div className="input-box" style={{ marginTop: "15px" }}>
//               <Button
//                 loading={loader}
//                 type="primary"
//                 style={{
//                   fontSize: "12px",
//                   color: "#fff",
//                 }}
//                 className="save_btn"
//                 onClick={ADD_OIL_RECORD_LOGBOOK_APIS}
//               >
//                 Save
//               </Button>
//             </div>
//           )}
//         </>
//       </div>
//       <div className="white-container">
//         <Table
//           bordered
//           columns={columns}
//           dataSource={tankList}
//           pagination={{ pageSize: 10 }}
//           rowKey="key"
//           className="custom-table"
//         />
//       </div>

//       <AddOliRecordLogPartOneModal
//         visible={open}
//         onClose={() => setOpen(false)}
//         onSuccess={() => {}}
//         parent_id={parent_id}
//       />
//     </>
//   );
// }

// export default AddOliRecordLogPartOne;



import { Button, message, Switch, Table, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ErrorToast,
  ShowInputError,
  SuccessToast,
} from "../../../widgets/AppToast";
import AppInput from "../../../components/AppInput";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import SelectInput from "../../../components/SelectInput";
import VoyageDetails from "../../../components/VoyageDetails";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";
import useDocumentUpload from "../../../hooks/useDocumentUpload";
import useUserData from "../../../hooks/useUserData";
import TextArea from "antd/es/input/TextArea";
import AddOliRecordLogPartOneModal from "./components/IcodeAddEntry";
import PdfPreviewModal from "../../common/pdfreviewbutton";
import { formatDate } from "../../../utils/dateFormatter";
import OrbPart1StructuredForm from "./components/OrbPart1StructuredForm";
import "./orbPart1Add.css";

function AddOliRecordLogPartOne() {
  const navigate = useNavigate();
  const user = useUserData();
  const designation = user?.data?.designation;
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [code, set_code] = useState("");
  const [date, set_date] = useState(moment().format("YYYY-MM-DD"));
  const [signature, set_signature] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [parent_id, set_parent_id] = useState("");
  const { documentList, handleDocumentChange, getFilesForUpload } =
    useDocumentUpload();
  const [previous_log_date, set_Previous_Log_Date] = useState("");
  const [tankList, SetTankList] = useState([]);
  const [enhancedEntry, setEnhancedEntry] = useState({ operationKey: "", data: {}, officerId: "", ready: false, preview: [] });

  console.log('selectedItems **************',selectedItems)


  const LIST_OIL_RECORD_CODE_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("orb_part", "1");
      post(ApiURL.list_code_categories_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRespones = res?.code_categories?.map((item) => {
            return {
              value: item?.id,
              label: `(${item?.value}) ` + item?.label,
              code: item?.value,
            };
          });
          LIST_OIL_RECORD_ITEM_API(newRespones?.[0]?.value);
          setCodeList(newRespones);
          set_Previous_Log_Date(res?.last_record);
        }
      });
    } catch (error) {
      console.error("Error fetching Code list:", error);
    }
  };

  const LIST_OIL_RECORD_ITEM_API = (code_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("code_category_id", code_id);
      FORM_DATA.append("orb_part", "1");
      post(ApiURL.list_subdetails_category_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRes = res?.subdetails?.map((item) => {
            return {
              value: item?.id,
              label: item?.sub_code_name,
              sub_code_name: item?.subdetails_child,
            };
          });
          setCodeItemList(newRes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code Item list:", error);
    }
  };

  const SEND_NOTIFICATION_CHIEF_ENGINEER = async (record_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      FORM_DATA.append("orb_part", "1");
      FORM_DATA.append("record_id", record_id);
      FORM_DATA.append(
        "description",
        "A new ORB Part 1 record has been created. Please review and confirm it at your earliest convenience"
      );
      const response = await post(ApiURL?.notification_save_req, FORM_DATA);
      if (response?.status === true) {
        SuccessToast(
          "Congratulations!",
          response?.message || "No message returned."
        );
      } else {
        ErrorToast("Error", response?.message || "Something went wrong.");
      }
    } catch (error) {
      ErrorToast(
        "Request Failed",
        "Could not complete the request. Please try again."
      );
    }
  };

  const ADD_OIL_RECORD_LOGBOOK_APIS = async (checked1) => {
    const files = getFilesForUpload();
    set_loader(true);
    if (!enhancedEntry.operationKey || !enhancedEntry.officerId) {
      ErrorToast("Required fields", "Select an operation and an active operation in-charge.");
      set_loader(false);
      return;
    }
    const enhanced = Boolean(enhancedEntry.operationKey);
    if (!enhanced &&
      selectedItems?.some((item) => item.value === null || item.value === "")
    ) {
      alert("All checked input should be filled");
      set_loader(false);
      return;
    }
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      FORM_DATA.append("orb_part", "1");
      FORM_DATA.append("code_category_id", code);
      const compatibilityValues = enhanced
        ? (enhancedEntry.preview.length ? enhancedEntry.preview : [enhancedEntry.operationKey]).map((value, index) => ({ id: `${enhancedEntry.operationKey}-${index}`, value }))
        : selectedItems;
      FORM_DATA.append("sub_detail_id", JSON.stringify(compatibilityValues));
      FORM_DATA.append("sub_detail_values", JSON.stringify(compatibilityValues));
      FORM_DATA.append("date", date);
      FORM_DATA.append("operation_details", signature || "Enhanced ORB entry");
      if (enhanced) {
        FORM_DATA.append("operation_key", enhancedEntry.operationKey);
        FORM_DATA.append("structured_data", JSON.stringify(enhancedEntry.data));
        FORM_DATA.append("operation_in_charge_id", enhancedEntry.officerId);
      }
      files?.forEach((files) => {
        FORM_DATA.append("files", files);
      });
      post(ApiURL.add_orb_details_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Congratulation!!", res?.message);
          set_loader(false);
          set_parent_id(res?.id);
          if (designation && designation !== "Chief Engineer") {
            SEND_NOTIFICATION_CHIEF_ENGINEER(res?.id);
          }
          if (code !== 30) {
            navigate("/list-oil-record-log-one");
          }
          //  navigate("/list-oil-record-log-one");
        } else {
          ErrorToast("Error message", res?.message);
          const error = res?.response?.data?.errors || {};

          set_errors(error);
          set_loader(false);
        }
      });
    } catch (error) {
      console.log("Errors *****", error);
    }
  };

  const SHIP_TANKS_LIST_API = async () => {
    try {
      const FORM_DATA = new FormData();
      const staff_Details = JSON.parse(localStorage.getItem("user_data"));
      FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
      FORM_DATA.append("category_of_tank", "IOPP");
      post(ApiURL.list_tanks_by_ship, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SetTankList(res?.tanks);
        }
      });
    } catch (error) {
      console.error("Error fetching Sub Tanks list:", error);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    LIST_OIL_RECORD_CODE_API();
    SHIP_TANKS_LIST_API();
  }, []);

  const groupedOptions = codeItemList.flatMap((item) => {
    if (item.sub_code_name.length > 0) {
      return {
        label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
        options: item.sub_code_name.map((sub, index) => ({
          value: `${item.value}-${index}`,
          label: ` ${sub?.subdetails_child}`,
        })),
      };
    } else {
      return {
        value: item.value,
        label: item.label,
      };
    }
  });

  const handleCheckboxChange = (value) => {
    setSelectedItems((prevItems) => {
      const exists = prevItems.find((item) => item.id === value);
      if (exists) {
        return prevItems.filter((item) => item.id !== value);
      } else {
        return [...prevItems, { id: value, value: "" }];
      }
    });
  };

  const handleInputChange = (id, value, key = "value") => {
    setSelectedItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [key]: value } : item))
    );
  };




const handleSpecialInputChange = (id, value, key = "specialValue") => {
  if (!/^[0-9A-Za-z.\s]*$/.test(value)) return; // Only allow alphanumeric + dot
  if (value.startsWith(".")) return; // No dot as first char
  if (value.length === 1 && !/^[0-9]$/.test(value)) return; // Must start with number
  if ((value.match(/\./g) || []).length > 1) return; // Only one dot allowed

  set_errors((prev) => ({ ...prev, [key]: "" }));

  setSelectedItems((prev) =>
    prev.map((item) =>
      item.id === id
        ? {
            ...item,
            [key]: value.toUpperCase(), 
            value: value.toUpperCase(), 
          }
        : item
    )
  );
};



  const getDocUrl = (file) => {
    if (file.url) return file.url; // existing file
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const handlePreviews = async (file) => {
    const url = getDocUrl(file);
    if (!url) {
      message.error("No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (checked) {
      setOpen(true);
    }
  }, [checked, parent_id]);

  const hasFormChanged = () => {
    if (enhancedEntry.operationKey) return enhancedEntry.ready;
    return (
      code &&
      date &&
      signature &&
      selectedItems.length > 0 &&
      selectedItems.every((item) => item.value && item.value.trim() !== "")
    );
  };

  const columns = [
    { title: "ID", dataIndex: "id", key: "id", align: "center" },
    {
      title: "Tank Name",
      dataIndex: "sub_tank_name",
      key: "sub_tank_name",
      align: "center",
    },
    {
      title: "Max capacity",
      dataIndex: "capacity",
      key: "capacity",
      align: "center",
    },
    {
      title: "Tank Type",
      dataIndex: "tank_type",
      key: "tank_type",
      align: "center",
    },
    {
      title: "Category",
      dataIndex: "category_name",
      key: "category_name",
      align: "center",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => <span>{formatDate(record?.created_at)}</span>,
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => <span>{formatDate(record?.updated_at)}</span>,
    },
  ];

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container orb-add-page">
        <header className="orb-page-header">
          <div><div className="orb-page-eyebrow">Statutory logbook</div><h3>Oil Record Book — Part I</h3><p>Machinery-space operations (all ships)</p></div>
          <PdfPreviewModal pdfFileName="ORB-PART-1.pdf" />
        </header>
        <section className="orb-entry-context">
          <div className="orb-context-field">
            <SelectInput
              label="Code"
              value={code}
              placeholder="Select ORB Part I code"
              style={{ width: "100%" }}
              onChange={(value) => {
                if (value !== 30) {
                  setChecked(false);
                }
                set_code(value);
                setSelectedItems([]);
                setEnhancedEntry({ operationKey: "", data: {}, officerId: "", ready: false, preview: [] });
                LIST_OIL_RECORD_ITEM_API(value);
              }}
              options={codeList}
              errors={errors?.code_category_id}
            />
          </div>
          <div className="orb-context-field">
            <AppInput
              type="date"
              label="Date"
              placeholder="Date"
              value={date}
              onChange={(e) => set_date(e.target.value)}
              errors={errors.date}
              showInfo={code === 30}
              infoMessage="Current Date - When the missed entry is being logged"
              min={previous_log_date}
              max={new Date().toISOString().split("T")[0]}
            />
          </div>
        </section>

        {code == 30 && (
          <div
            className="row"
            style={{ marginLeft: "5px", marginBottom: "7px" }}
          >
            <div style={{ marginRight: "5px" }}>
              <label>
                Do you want to record a missed operation entry (Yes / No)
              </label>
            </div>
            <Switch
              value={checked}
              onChange={(checked) => {
                if (hasFormChanged()) {
                  setChecked(checked);
                  ADD_OIL_RECORD_LOGBOOK_APIS("checked");
                }
              }}
              checkedChildren="No"
              unCheckedChildren="Yes"
              style={{
                backgroundColor: checked ? "green" : "red",
              }}
            />
          </div>
        )}

        <>
          {code && (
            <OrbPart1StructuredForm
              codeLetter={codeList.find((item) => String(item.value) === String(code))?.code}
              entryDate={date}
              filesCount={getFilesForUpload()?.length || 0}
              onChange={setEnhancedEntry}
            />
          )}
          {false && code && (
            <div
              className="col-12"
              style={{
                lineHeight: "2",
                border: "1px solid #d9d9d9",
                borderRadius: "5px",
                marginBottom: "5px",
              }}
            >
              <strong className="form-label">Select Items:</strong>
              {groupedOptions.map((optionGroup, index) => (
                <div key={index} className="mb-3">
                  {/* Main Label as Checkbox */}
                  <div className="row align-items-center mb-2">
                    <div className="col-6">
                      <div className="form-check">
                        {optionGroup?.options?.length > 1 ? (
                          ""
                        ) : (
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={optionGroup.label}
                            checked={selectedItems.some(
                              (item) => item.id === optionGroup.value
                            )}
                            onChange={() =>
                              handleCheckboxChange(optionGroup.value)
                            }
                            id={`group-checkbox-${index}`}
                          />
                        )}
                        <label
                          className="form-check-label"
                          htmlFor={`group-checkbox-${index}`}
                        >
                          {typeof optionGroup.label === "string" ? (
                            <strong>{optionGroup.label}</strong>
                          ) : (
                            <strong>{optionGroup.label.props.children}</strong>
                          )}
                        </label>
                      </div>
                    </div>

                    {/* Input Field for Main Label */}
                    <div className="col-6" style={{ marginLeft: "22px" }}>
                      {selectedItems.some(
                        (item) => item.id === optionGroup.value
                      ) && (
                        Number(optionGroup.value) === 112 ?  <>
                       <TextArea
                        required
                        maxLength={1000}
                        className={`form-control ${
                          errors?.specialInput ? "border border-danger" : ""
                        }`}
                        autoSize={{ minRows: 2 }}
                        // placeholder="Enter value like 1.23A"
                        placeholder="Always start the sentence in Item 13 with the total quantity discharged. Our system will only look at that first number for our records."
                        value={
                          selectedItems.find((item) => item.id === optionGroup.value)
                            ?.specialValue || ""
                        }
                        onChange={(e) =>
                          handleSpecialInputChange(optionGroup.value, e.target.value)
                        }
                      />
                      {errors?.specialInput && (
                        <p style={{ color: "red", marginTop: "4px" }}>
                          {errors.specialInput}
                        </p>
                      )}
                    </>:
                        <TextArea
                          required
                          maxLength={1000}
                          className="form-control"
                          autoSize={{ minRows: 2 }}
                          placeholder={
                            typeof optionGroup.label === "string"
                              ? optionGroup.label
                              : optionGroup.label.props.children
                          }
                          value={
                            selectedItems.find(
                              (item) => item.id === optionGroup.value
                            )?.value || ""
                          }
                          onChange={(e) =>
                            handleInputChange(optionGroup.value, e.target.value)
                          }
                        />
                      )}
                    </div>

                    {/* Special Input - Only for 112 */}
                    {/* {Number(optionGroup.value) === 112 && (
                      <div className="col-6" style={{ marginBottom: 20 }}>
                        {selectedItems.some(
                          (item) => Number(item.id) === 112
                        ) && (
                          <TextArea
                            required
                            maxLength={1000}
                            className="form-control"
                            autoSize={{ minRows: 2 }}
                            placeholder="Discharged Volume"
                            value={
                              selectedItems.find(
                                (item) => Number(item.id) === 112
                              )?.dischargedvolume || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                112,
                                e.target.value,
                                "dischargedvolume"
                              )
                            }
                          />
                        )}
                      </div>
                    )} */}
                  </div>

                  {/* Sub-options */}
                  {optionGroup.options && (
                    <div
                      className="ms-3"
                      style={{ marginLeft: "30px", padding: "10px" }}
                    >
                      {optionGroup.options.map((option) => (
                        <div
                          key={option.value}
                          className="row align-items-center mb-2"
                        >
                          {/* Left Side - Checkbox */}
                          <div className="col-6">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value={option.value}
                                checked={selectedItems.some(
                                  (item) => item.id === option.value
                                )}
                                onChange={() =>
                                  handleCheckboxChange(option.value)
                                }
                                id={`checkbox-${option.value}`}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`checkbox-${option.value}`}
                              >
                                {option.label}
                              </label>
                            </div>
                          </div>

                          {/* Right Side - Input Field */}
                          {/* <div className="col-6" style={{ padding: "5px" }}>
                            {selectedItems.some(
                              (item) => item.id === option.value
                            ) && (
                              <TextArea
                                required
                                maxLength={1000}
                                className="form-control"
                                autoSize={{ minRows: 2 }}
                                placeholder={option.label}
                                value={
                                  selectedItems.find(
                                    (item) => item.id === option.value
                                  )?.value || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    option.value,
                                    e.target.value
                                  )
                                }
                              />
                            )}
                          </div> */}
                           <div className="col-6" style={{ padding: "5px" }}>
              {selectedItems.some((item) => item.id === option.value) && (
                <>
                  {/* Special case: only show this special input when id=111-3 & code=24 */}
                  {option.value === "111-3" && code === 24 ? (
                    <>
                      <TextArea
                        required
                        maxLength={1000}
                        className={`form-control ${
                          errors?.specialInput ? "border border-danger" : ""
                        }`}
                        autoSize={{ minRows: 2 }}
                        // placeholder="Enter value like 1.23A"
                        placeholder="Always start the sentence in Item 12.4 with the total quantity evaporated. Our system will only look at that first number for our records."
                        value={
                          selectedItems.find((item) => item.id === option.value)
                            ?.specialValue || ""
                        }
                        onChange={(e) =>
                          handleSpecialInputChange(option.value, e.target.value)
                        }
                      />
                      {errors?.specialInput && (
                        <p style={{ color: "red", marginTop: "4px" }}>
                          {errors.specialInput}
                        </p>
                      )}
                    </>
                  ) : (
                    <TextArea
                      required
                      maxLength={1000}
                      className="form-control"
                      autoSize={{ minRows: 2 }}
                      placeholder={option.label}
                      value={
                        selectedItems.find((item) => item.id === option.value)?.value || ""
                      }
                      onChange={(e) => handleInputChange(option.value, e.target.value)}
                    />
                  )}

                </>
              )}
            </div>

                          {/* Special case: two inputs only for id '111-3' and code '24' */}
                          {/* First Input - Only for id 111-3 */}
                          {/* {option.value === "111-3" && (
                            <div className="col-6" style={{ padding: "5px" }}>
                              {selectedItems.some(
                                (item) => item.id === option.value
                              ) && (
                                <TextArea
                                  required
                                  maxLength={1000}
                                  className="form-control"
                                  autoSize={{ minRows: 2 }}
                                  placeholder={"Evaporation Volume"}
                                  value={
                                    selectedItems.find(
                                      (item) => item.id === option.value
                                    )?.evaporationVolume || ""
                                  }
                                  onChange={(e) =>
                                    handleInputChange(
                                      option.value,
                                      e.target.value,
                                      "evaporationVolume"
                                    )
                                  }
                                />
                              )}
                            </div>
                          )} */}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {errors.sub_detail_values && (
            <ShowInputError errorMessage={errors.sub_detail_values} />
          )}
          <div className="orb-entry-footer">
            {false && <>
            <div className="col-6">
              <AppInput
                label="Name of operation incharge"
                placeholder="Name of operation incharge"
                value={signature}
                onChange={(e) => set_signature(e.target.value)}
                errors={errors.operation_details}
                showInfo={code === 30}
                infoMessage="Officer making this entry now"
              />
            </div>
            </>}
            {!checked && (
              <div className="orb-attachment-section">
                <div className="orb-attachment-copy"><strong>Supporting documents</strong><span>Attach applicable receipts or certificates in PDF, Word, or Excel format.</span></div>
                <div className="input-box orb-upload-control">
                  <Upload
                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                    multiple
                    fileList={documentList}
                    onChange={handleDocumentChange}
                    onPreview={handlePreviews}
                    beforeUpload={() => false}
                    listType="picture"
                  >
                    <Button
                      icon={<UploadOutlined />}
                    >Attach documents</Button>
                  </Upload>
                </div>
              </div>
            )}
          </div>
          {!checked && (
            <div className="orb-submit-bar">
              <div><strong>Final submission</strong><span>Validate and review the generated ORB entry before saving.</span></div>
              <Button
                loading={loader}
                type="primary"
                className="save_btn"
                onClick={ADD_OIL_RECORD_LOGBOOK_APIS}
              >
                Save ORB Entry
              </Button>
            </div>
          )}
        </>
      </div>
      <div className="white-container">
        <Table
          bordered
          columns={columns}
          dataSource={tankList}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          className="custom-table"
        />
      </div>

      <AddOliRecordLogPartOneModal
        visible={open}
        onClose={() => setOpen(false)}
        onSuccess={() => {}}
        parent_id={parent_id}
      />
    </>
  );
}

export default AddOliRecordLogPartOne;




// import { Button, message, Switch, Table, Upload } from "antd";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   ErrorToast,
//   ShowInputError,
//   SuccessToast,
// } from "../../../widgets/AppToast";
// import AppInput from "../../../components/AppInput";
// import { post } from "../../../services/services";
// import { ApiURL } from "../../../services/apiConstants";
// import SelectInput from "../../../components/SelectInput";
// import VoyageDetails from "../../../components/VoyageDetails";
// import moment from "moment";
// import { UploadOutlined } from "@ant-design/icons";
// import useDocumentUpload from "../../../hooks/useDocumentUpload";
// import useUserData from "../../../hooks/useUserData";
// import TextArea from "antd/es/input/TextArea";
// import AddOliRecordLogPartOneModal from "./components/IcodeAddEntry";
// import PdfPreviewModal from "../../common/pdfreviewbutton";
// import { formatDate } from "../../../utils/dateFormatter";

// function AddOliRecordLogPartOne() {
//   const navigate = useNavigate();
//   const user = useUserData();
//   const designation = user?.data?.designation;
//   const [loader, set_loader] = useState(false);
//   const [errors, set_errors] = useState({});
//   const [staff_dashboard, set_staff_dashboard] = useState([]);
//   const [code, set_code] = useState("");
//   const [date, set_date] = useState(moment().format("YYYY-MM-DD"));
//   const [signature, set_signature] = useState("");
//   const [codeList, setCodeList] = useState([]);
//   const [codeItemList, setCodeItemList] = useState([]);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [checked, setChecked] = useState(false);
//   const [parent_id, set_parent_id] = useState("");
//   const { documentList, handleDocumentChange, getFilesForUpload } =
//     useDocumentUpload();
//   const [previous_log_date, set_Previous_Log_Date] = useState("");
//   const [tankList, SetTankList] = useState([]);


//   const LIST_OIL_RECORD_CODE_API = () => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("orb_part", "1");
//       post(ApiURL.list_code_categories_st, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           const newRespones = res?.code_categories?.map((item) => {
//             return {
//               value: item?.id,
//               label: `(${item?.value}) ` + item?.label,
//             };
//           });
//           LIST_OIL_RECORD_ITEM_API(newRespones?.[0]?.value);
//           setCodeList(newRespones);
//           set_Previous_Log_Date(res?.last_record);
//         }
//       });
//     } catch (error) {
//       console.error("Error fetching Code list:", error);
//     }
//   };

//   const LIST_OIL_RECORD_ITEM_API = (code_id) => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("code_category_id", code_id);
//       FORM_DATA.append("orb_part", "1");
//       post(ApiURL.list_subdetails_category_st, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           const newRes = res?.subdetails?.map((item) => {
//             return {
//               value: item?.id,
//               label: item?.sub_code_name,
//               sub_code_name: item?.subdetails_child,
//             };
//           });
//           setCodeItemList(newRes);
//         }
//       });
//     } catch (error) {
//       console.error("Error fetching Code Item list:", error);
//     }
//   };

//   const SEND_NOTIFICATION_CHIEF_ENGINEER = async (record_id) => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
//       FORM_DATA.append("orb_part", "1");
//       FORM_DATA.append("record_id", record_id);
//       FORM_DATA.append(
//         "description",
//         "A new ORB Part 1 record has been created. Please review and confirm it at your earliest convenience"
//       );
//       const response = await post(ApiURL?.notification_save_req, FORM_DATA);
//       if (response?.status === true) {
//         SuccessToast(
//           "Congratulations!",
//           response?.message || "No message returned."
//         );
//       } else {
//         ErrorToast("Error", response?.message || "Something went wrong.");
//       }
//     } catch (error) {
//       ErrorToast(
//         "Request Failed",
//         "Could not complete the request. Please try again."
//       );
//     }
//   };

//   const ADD_OIL_RECORD_LOGBOOK_APIS = async (checked1) => {
//     const files = getFilesForUpload();
//     set_loader(true);
//     if (
//       selectedItems?.some((item) => item.value === null || item.value === "")
//     ) {
//       alert("All checked input should be filled");
//       set_loader(false);
//       return;
//     }
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
//       FORM_DATA.append("orb_part", "1");
//       FORM_DATA.append("code_category_id", code);
//       FORM_DATA.append("sub_detail_id", JSON.stringify(selectedItems));
//       FORM_DATA.append("sub_detail_values", JSON.stringify(selectedItems));
//       FORM_DATA.append("date", date);
//       FORM_DATA.append("operation_details", signature);
//       files?.forEach((files) => {
//         FORM_DATA.append("files", files);
//       });
//       post(ApiURL.add_orb_details_st, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           SuccessToast("Congratulation!!", res?.message);
//           set_loader(false);
//           set_parent_id(res?.id);
//           if (designation && designation !== "Chief Engineer") {
//             SEND_NOTIFICATION_CHIEF_ENGINEER(res?.id);
//           }
//           if (code !== 30) {
//             navigate("/list-oil-record-log-one");
//           }
//           //  navigate("/list-oil-record-log-one");
//         } else {
//           ErrorToast("Error message", res?.message);
//           const error = res?.response?.data?.errors || {};

//           set_errors(error);
//           set_loader(false);
//         }
//       });
//     } catch (error) {
//       console.log("Errors *****", error);
//     }
//   };

//   const SHIP_TANKS_LIST_API = async () => {
//     try {
//       const FORM_DATA = new FormData();
//       const staff_Details = JSON.parse(localStorage.getItem("user_data"));
//       FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
//       FORM_DATA.append("category_of_tank", "IOPP");
//       post(ApiURL.list_tanks_by_ship, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           SetTankList(res?.tanks);
//         }
//       });
//     } catch (error) {
//       console.error("Error fetching Sub Tanks list:", error);
//     }
//   };

//   useEffect(() => {
//     const staff_dashboards = localStorage.getItem("staff_dashboard");
//     const parsedData = JSON.parse(staff_dashboards);
//     set_staff_dashboard(parsedData);
//     LIST_OIL_RECORD_CODE_API();
//     SHIP_TANKS_LIST_API();
//   }, []);

//   const groupedOptions = codeItemList.flatMap((item) => {
//     if (item.sub_code_name.length > 0) {
//       return {
//         label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
//         options: item.sub_code_name.map((sub, index) => ({
//           value: `${item.value}-${index}`,
//           label: ` ${sub?.subdetails_child}`,
//         })),
//       };
//     } else {
//       return {
//         value: item.value,
//         label: item.label,
//       };
//     }
//   });

//   const handleCheckboxChange = (value) => {
//     setSelectedItems((prevItems) => {
//       const exists = prevItems.find((item) => item.id === value);
//       if (exists) {
//         return prevItems.filter((item) => item.id !== value);
//       } else {
//         return [...prevItems, { id: value, value: "" }];
//       }
//     });
//   };

//   const handleInputChange = (id, value, key = "value") => {
//     setSelectedItems((prev) =>
//       prev.map((item) => (item.id === id ? { ...item, [key]: value } : item))
//     );
//   };

//   const getDocUrl = (file) => {
//     if (file.url) return file.url; // existing file
//     if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
//     return null;
//   };

//   const handlePreviews = async (file) => {
//     const url = getDocUrl(file);
//     if (!url) {
//       message.error("No preview available for this file");
//       return;
//     }
//     window.open(url, "_blank");
//   };

//   useEffect(() => {
//     if (checked) {
//       setOpen(true);
//     }
//   }, [checked, parent_id]);

//   const hasFormChanged = () => {
//     return (
//       code &&
//       date &&
//       signature &&
//       selectedItems.length > 0 &&
//       selectedItems.every((item) => item.value && item.value.trim() !== "")
//     );
//   };



// const handleSpecialInputChange = (id, value) => {
//   // Allow only alphanumeric and dot characters
//   const allowedChars = /^[0-9A-Za-z.]*$/;
//   if (!allowedChars.test(value)) return; // block invalid chars like @, #

//   // Must start with a number
//   if (value.length === 1 && !/^[0-9]$/.test(value)) return;

//   // Disallow multiple dots
//   const dotCount = (value.match(/\./g) || []).length;
//   if (dotCount > 1) return;

//   // Optional: Disallow dot as first char
//   if (value.startsWith('.')) return;

//   // No errors if it follows above progressive rules
//   set_errors((prev) => ({ ...prev, specialInput: "" }));

//   // Update selected item
//   setSelectedItems((prev) =>
//     prev.map((item) =>
//       item.id === id ? { ...item, specialValue: value.toUpperCase() } : item
//     )
//   );
// };


// // const handleSpecialInputChange = (id, value, inputType = "default") => {
// //   // Allow only alphanumeric and dot characters
// //   const allowedChars = /^[0-9A-Za-z.]*$/;
// //   if (!allowedChars.test(value)) return; // block invalid chars like @, #

// //   // Must start with a number
// //   if (value.length === 1 && !/^[0-9]$/.test(value)) return;

// //   // Disallow multiple dots
// //   const dotCount = (value.match(/\./g) || []).length;
// //   if (dotCount > 1) return;

// //   // Disallow dot as first char
// //   if (value.startsWith(".")) return;

// //   // Validate specific case
// //   if (inputType === "112" && value.length > 6) {
// //     set_errors((prev) => ({
// //       ...prev,
// //       specialInput112: "Value too long — must be ≤ 6 characters",
// //     }));
// //     return;
// //   }

// //   // Clear errors
// //   set_errors((prev) => ({
// //     ...prev,
// //     specialInput: "",
// //     specialInput112: "",
// //   }));

// //   // Update selected item
// //   setSelectedItems((prev) =>
// //     prev.map((item) =>
// //       item.id === id ? { ...item, specialValue: value.toUpperCase() } : item
// //     )
// //   );
// // };


//   const columns = [
//     { title: "ID", dataIndex: "id", key: "id", align: "center" },
//     {
//       title: "Tank Name",
//       dataIndex: "sub_tank_name",
//       key: "sub_tank_name",
//       align: "center",
//     },
//     {
//       title: "Max capacity",
//       dataIndex: "capacity",
//       key: "capacity",
//       align: "center",
//     },
//     {
//       title: "Tank Type",
//       dataIndex: "tank_type",
//       key: "tank_type",
//       align: "center",
//     },
//     {
//       title: "Category",
//       dataIndex: "category_name",
//       key: "category_name",
//       align: "center",
//     },
//     {
//       title: "Created Date",
//       dataIndex: "created_at",
//       align: "center",
//       key: "created_at",
//       render: (text, record) => <span>{formatDate(record?.created_at)}</span>,
//     },
//     {
//       title: "Updated Date",
//       dataIndex: "updated_at",
//       align: "center",
//       key: "updated_at",
//       render: (text, record) => <span>{formatDate(record?.updated_at)}</span>,
//     },
//   ];

//   return (
//     <>
//       <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
//       <div className="white-container">
//         <br />
//         <div className="col-6" style={{ marginLeft: "-10px" }}>
//           <h3>Oil Record book Part 1 Information</h3>
//         </div>
//         <div className="col-6">
//           <PdfPreviewModal pdfFileName="ORB-PART-1.pdf" />
//         </div>
//         <br />
//         <br />
//         <div className="row">
//           <div className="col-6">
//             <SelectInput
//               label="Code"
//               value={code}
//               placeholder=" -- Selecte Code  -- "
//               style={{ width: "100%" }}
//               onChange={(value) => {
//                 if (value !== 30) {
//                   setChecked(false);
//                 }
//                 set_code(value);
//                 setSelectedItems([]);
//                 LIST_OIL_RECORD_ITEM_API(value);
//               }}
//               options={codeList}
//               errors={errors?.code_category_id}
//             />
//           </div>

//           <div className="col-6">
//             <AppInput
//               type="date"
//               label="Date"
//               placeholder="Date"
//               value={date}
//               onChange={(e) => set_date(e.target.value)}
//               errors={errors.date}
//               showInfo={code === 30}
//               infoMessage="Current Date - When the missed entry is being logged"
//               min={previous_log_date}
//               max={new Date().toISOString().split("T")[0]}
//             />
//           </div>
//         </div>

//         {code == 30 && (
//           <div
//             className="row"
//             style={{ marginLeft: "5px", marginBottom: "7px" }}
//           >
//             <div style={{ marginRight: "5px" }}>
//               <label>
//                 Do you want to record a missed operation entry (Yes / No)
//               </label>
//             </div>
//             <Switch
//               value={checked}
//               onChange={(checked) => {
//                 if (hasFormChanged()) {
//                   setChecked(checked);
//                   ADD_OIL_RECORD_LOGBOOK_APIS("checked");
//                 }
//               }}
//               checkedChildren="No"
//               unCheckedChildren="Yes"
//               style={{
//                 backgroundColor: checked ? "green" : "red",
//               }}
//             />
//           </div>
//         )}

//         <>
//           {code && (
//             <div
//               className="col-12"
//               style={{
//                 lineHeight: "2",
//                 border: "1px solid #d9d9d9",
//                 borderRadius: "5px",
//                 marginBottom: "5px",
//               }}
//             >
//               <strong className="form-label">Select Items:</strong>
//               {groupedOptions.map((optionGroup, index) => (
//                 <div key={index} className="mb-3">
//                   {/* Main Label as Checkbox */}
//                   <div className="row align-items-center mb-2">
//                     <div className="col-6">
//                       <div className="form-check">
//                         {optionGroup?.options?.length > 1 ? (
//                           ""
//                         ) : (
//                           <input
//                             className="form-check-input"
//                             type="checkbox"
//                             value={optionGroup.label}
//                             checked={selectedItems.some(
//                               (item) => item.id === optionGroup.value
//                             )}
//                             onChange={() =>
//                               handleCheckboxChange(optionGroup.value)
//                             }
//                             id={`group-checkbox-${index}`}
//                           />
//                         )}
//                         <label
//                           className="form-check-label"
//                           htmlFor={`group-checkbox-${index}`}
//                         >
//                           {typeof optionGroup.label === "string" ? (
//                             <strong>{optionGroup.label}</strong>
//                           ) : (
//                             <strong>{optionGroup.label.props.children}</strong>
//                           )}
//                         </label>
//                       </div>
//                     </div>

//                     {/* Input Field for Main Label */}
//                     <div className="col-6" style={{ marginLeft: "22px" }}>
//                       {selectedItems.some(
//                         (item) => item.id === optionGroup.value
//                       ) && (
//                         <TextArea
//                           required
//                           maxLength={1000}
//                           className="form-control"
//                           autoSize={{ minRows: 2 }}
//                           placeholder={
//                             typeof optionGroup.label === "string"
//                               ? optionGroup.label
//                               : optionGroup.label.props.children
//                           }
//                           value={
//                             selectedItems.find(
//                               (item) => item.id === optionGroup.value
//                             )?.value || ""
//                           }
//                           onChange={(e) =>
//                             handleInputChange(optionGroup.value, e.target.value)
//                           }
//                         />
//                       )}
//                     </div>

//                     {/* Special Input - Only for 112 */}
//                     {/* {Number(optionGroup.value) === 112 && (
//                       <div className="col-6" style={{ marginBottom: 20 }}>
//                         {selectedItems.some(
//                           (item) => Number(item.id) === 112
//                         ) && (
//                           <TextArea
//                             required
//                             maxLength={1000}
//                             className="form-control"
//                             autoSize={{ minRows: 2 }}
//                             placeholder="Discharged Volume"
//                             value={
//                               selectedItems.find(
//                                 (item) => Number(item.id) === 112
//                               )?.dischargedvolume || ""
//                             }
//                             onChange={(e) =>
//                               handleInputChange(
//                                 112,
//                                 e.target.value,
//                                 "dischargedvolume"
//                               )
//                             }
//                           />
//                         )}
//                       </div>
//                     )} */}
//                   </div>

//                   {/* Sub-options */}
//                   {optionGroup.options && (
//                     <div
//                       className="ms-3"
//                       style={{ marginLeft: "30px", padding: "10px" }}
//                     >
//                       {optionGroup.options.map((option) => (
//                         <div
//                           key={option.value}
//                           className="row align-items-center mb-2"
//                         >
//                           {/* Left Side - Checkbox */}
//                           <div className="col-6">
//                             <div className="form-check">
//                               <input
//                                 className="form-check-input"
//                                 type="checkbox"
//                                 value={option.value}
//                                 checked={selectedItems.some(
//                                   (item) => item.id === option.value
//                                 )}
//                                 onChange={() =>
//                                   handleCheckboxChange(option.value)
//                                 }
//                                 id={`checkbox-${option.value}`}
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor={`checkbox-${option.value}`}
//                               >
//                                 {option.label}
//                               </label>
//                             </div>
//                           </div>

//                           {/* Right Side - Input Field */}
//                           {/* <div className="col-6" style={{ padding: "5px" }}>
//                             {selectedItems.some(
//                               (item) => item.id === option.value
//                             ) && (
//                               <TextArea
//                                 required
//                                 maxLength={1000}
//                                 className="form-control"
//                                 autoSize={{ minRows: 2 }}
//                                 placeholder={option.label}
//                                 value={
//                                   selectedItems.find(
//                                     (item) => item.id === option.value
//                                   )?.value || ""
//                                 }
//                                 onChange={(e) =>
//                                   handleInputChange(
//                                     option.value,
//                                     e.target.value
//                                   )
//                                 }
//                               />
//                             )}
//                           </div> */}

//                           {/* Right Side - Input Field */}
//             <div className="col-6" style={{ padding: "5px" }}>
//               {selectedItems.some((item) => item.id === option.value) && (
//                 <>
//                   {/* Special case: only show this special input when id=111-3 & code=24 */}
//                   {option.value === "111-3" && code === 24 ? (
//                     <>
//                       <TextArea
//                         required
//                         maxLength={1000}
//                         className={`form-control ${
//                           errors?.specialInput ? "border border-danger" : ""
//                         }`}
//                         autoSize={{ minRows: 2 }}
//                         placeholder="Enter value like 1.23A"
//                         value={
//                           selectedItems.find((item) => item.id === option.value)
//                             ?.specialValue || ""
//                         }
//                         onChange={(e) =>
//                           handleSpecialInputChange(option.value, e.target.value)
//                         }
//                       />
//                       {errors?.specialInput && (
//                         <p style={{ color: "red", marginTop: "4px" }}>
//                           {errors.specialInput}
//                         </p>
//                       )}
//                     </>
//                   ) : (
//                     <TextArea
//                       required
//                       maxLength={1000}
//                       className="form-control"
//                       autoSize={{ minRows: 2 }}
//                       placeholder={option.label}
//                       value={
//                         selectedItems.find((item) => item.id === option.value)?.value || ""
//                       }
//                       onChange={(e) => handleInputChange(option.value, e.target.value)}
//                     />
//                   )}

//                 </>
//               )}
//             </div>

//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           )}
//           {errors.sub_detail_values && (
//             <ShowInputError errorMessage={errors.sub_detail_values} />
//           )}
//           <div className="row" style={{ alignItems: "center" }}>
//             <div className="col-6">
//               <AppInput
//                 label="Name of operation incharge"
//                 placeholder="Name of operation incharge"
//                 value={signature}
//                 onChange={(e) => set_signature(e.target.value)}
//                 errors={errors.operation_details}
//                 showInfo={code === 30}
//                 infoMessage="Officer making this entry now"
//               />
//             </div>
//             {!checked && (
//               <div className="col-6">
//                 <div
//                   className="input-box"
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "8px",
//                     alignItems: "flex-start",
//                   }}
//                 >
//                   <label>Select File</label>
//                   <Upload
//                     accept=".pdf,.doc,.docx,.xls,.xlsx"
//                     multiple
//                     fileList={documentList}
//                     onChange={handleDocumentChange}
//                     onPreview={handlePreviews}
//                     beforeUpload={() => false}
//                     listType="picture"
//                   >
//                     <Button
//                       icon={<UploadOutlined />}
//                       type="primary"
//                       style={{
//                         borderRadius: "50%",
//                         padding: "10px",
//                         width: "40px",
//                         height: "40px",
//                         marginLeft: "10px",
//                       }}
//                     ></Button>
//                   </Upload>
//                 </div>
//               </div>
//             )}
//           </div>
//           {!checked && (
//             <div className="input-box" style={{ marginTop: "15px" }}>
//               <Button
//                 loading={loader}
//                 type="primary"
//                 style={{
//                   fontSize: "12px",
//                   color: "#fff",
//                 }}
//                 className="save_btn"
//                 onClick={ADD_OIL_RECORD_LOGBOOK_APIS}
//               >
//                 Save
//               </Button>
//             </div>
//           )}
//         </>
//       </div>
//       <div className="white-container">
//         <Table
//           bordered
//           columns={columns}
//           dataSource={tankList}
//           pagination={{ pageSize: 10 }}
//           rowKey="key"
//           className="custom-table"
//         />
//       </div>

//       <AddOliRecordLogPartOneModal
//         visible={open}
//         onClose={() => setOpen(false)}
//         onSuccess={() => {}}
//         parent_id={parent_id}
//       />
//     </>
//   );
// }

// export default AddOliRecordLogPartOne;


